import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { IImovelFocus } from "../Pages/Cartorio_Pages/App_Pages/ImovelFocus";

import api from "../Services/api";
import { IPrefeitura } from "./usePrefeitura";

export interface IImovelFormatado {
  ID: number;
  LOCALIZACAO: string;
  BAIRRO: string;
  AREA: number;
  LOTE: string;
  QUADRA: string;
  ZONA: string | null;
  SUBLOTE: string | null;
  OPERACAO_ID: number;
  VALOR_CARTORIO_TERRENO: number | null;
  VALOR_CARTORIO_BENFEITORIAS: number | null;
  VALOR_PREFEITURA_TERRENO: number | null;
  VALOR_PREFEITURA_BENFEITORIAS: number | null;
  DATA_CRIACAO: string;
  ENVIADO: Date | null;
  AVALIADO: Date | null;
  PREFEITURA_ID: number;
  CARTORIO_ID: number;
  CARTORIO_TITULO: string;
  FRENTE: number | null;
  FUNDO: number | null;
  LADO_DIREITO: number | null;
  LADO_ESQUERDO: number | null;
  SITUACAO_QUADRA: string;
  MUNICIPIO: string;
  TRANSMITENTE: string;
  ADQUIRINTE: string;
  NUMERO: number;
  VENC: Date | null;
  APTIDAO_BOA: number;
  APTIDAO_REGULAR: number;
  APTIDAO_RESTRITA: number;
  PASTAGEM_PLANA: number;
  SIVICULTURA: number;
  RESERVA_NATURAL: number;
  MATRICULA: number;
  ENTRADA: number;
  ALIQUOTA2: number;
  TRANSCRICAO: string;
}

export interface IImovel {
  ID: number;
  LOCALIZACAO: string;
  BAIRRO: string;
  AREA: number;
  LOTE: string;
  QUADRA: string;
  ZONA: string | null;
  SUBLOTE: string | null;
  OPERACAO_ID: number;
  VALOR_CARTORIO_TERRENO: number | null;
  VALOR_CARTORIO_BENFEITORIAS: number | null;
  VALOR_PREFEITURA_TERRENO: number | null;
  VALOR_PREFEITURA_BENFEITORIAS: number | null;
  DATA_CRIACAO: string;
  ENVIADO: Date | null;
  AVALIADO: Date | null;
  PREFEITURA_ID: number;
  CARTORIO_ID: number;
  FRENTE: number | null;
  FUNDO: number | null;
  LADO_DIREITO: number | null;
  LADO_ESQUERDO: number | null;
  SITUACAO_QUADRA: string;
  NUMERO: number;
  VENC: Date | null;

  APTIDAO_BOA: number;
  APTIDAO_REGULAR: number;
  APTIDAO_RESTRITA: number;
  PASTAGEM_PLANA: number;
  SIVICULTURA: number;
  RESERVA_NATURAL: number;

  MATRICULA: number;
  TRANSCRICAO: string;
}

interface IImovelFormatadoContextData {
  newImovel: IImovelFormatado;
  handleSetNewImovel(imovel: IImovelFormatado): void;
  filtro: IFiltroImovel;
  handleSetFiltro(imovel: IFiltroImovel): void;
  imovelFocus: IImovelFocus;
  setImovelFocus: React.Dispatch<React.SetStateAction<IImovelFocus>>;
}

interface IImovelFormatadoProviderProps {
  children: ReactNode;
}

export interface IFiltroImovel {
  ativo: boolean;
  prefeitura_id: number | null;
  localizacao: string | null;
  transmitente: string | null;
  adquirinte: string | null;
  data_criacao: Date | null;
  data_envio: Date | null;
  data_avaliacao: Date | null;
}

const ImovelContext = createContext({} as IImovelFormatadoContextData);

function ImovelProvider({ children }: IImovelFormatadoProviderProps) {
  const [newImovel, setNewImovel] = useState({} as IImovelFormatado);
  const [filtro, setFiltro] = useState({} as IFiltroImovel);
  const [imovelFocus, setImovelFocus] = useState({} as IImovelFocus);
  function handleSetFiltro(filtro: IFiltroImovel) {
    setFiltro(filtro);
  }

  function handleSetNewImovel(imovel: IImovelFormatado) {
    setNewImovel(imovel);
  }

  useEffect(() => {
    // window.alert(filtro)
  }, [filtro]);

  return (
    <ImovelContext.Provider
      value={{
        newImovel,
        handleSetNewImovel,
        filtro,
        handleSetFiltro,
        imovelFocus,
        setImovelFocus,
      }}
    >
      <>{children}</>
    </ImovelContext.Provider>
  );
}

function useImovel() {
  const context = useContext(ImovelContext);

  return context;
}

export { ImovelProvider, useImovel };
